import { animateHeroElement } from './helpers';

export const campsHeroAnimation = () => {
	animateHeroElement(
		'.camps-left-image',
		{ rotate: -10 },
		{
			rotate: 0,
			x: 60,
			y: 34,
			duration: 1.5,
			ease: 'imageEasing',
		}
	);

	animateHeroElement(
		'.camps-left-square',
		{},
		{
			rotate: 30,
			x: 64,
			y: 34,
			duration: 1,
			delay: 0.5,
			ease: 'smoothEasing',
		}
	);

	animateHeroElement(
		'.camps-left-circle',
		{},
		{
			x: 47,
			y: 47,
			duration: 1,
			delay: 0.5,
			ease: 'smoothEasing',
		}
	);

	animateHeroElement(
		'.camps-right-image',
		{ rotate: -10 },
		{
			rotate: 0,
			x: -39,
			y: -32,
			duration: 1.5,
			ease: 'imageEasing',
		}
	);

	animateHeroElement(
		'.camps-right-circle',
		{},
		{
			x: -36,
			y: -54,
			duration: 1,
			delay: 0.5,
			ease: 'smoothEasing',
		}
	);
};
